import { Resource as e, API as a } from "@coveo/platform-client";
const t = class t extends e {
  /**
   * Returns a paginated list of search interface configurations for the specified project.
   *
   * @param {string | undefined} projectId ID of the project for which to retrieve search interface configurations.
   * @param {IListSearchInterfacesParameters} options Options to configure the request.
   * @returns {Promise<PageModel<ISearchInterfaceConfigurationResponse>>} Paginated list of search interface configurations for the specified project.
   */
  listSearchInterfacesByProjectId(i, r = {}) {
    return this.api.get(
      this.buildPath(`${t.baseUrl}/projects/interfaces`, {
        ...r,
        projectId: i
      })
    );
  }
};
t.baseUrl = `/rest/organizations/${a.orgPlaceholder}/searchinterfaces`;
let s = t;
export {
  s as SearchInterfacesInternalResource
};
//# sourceMappingURL=SearchInterfacesInternalResource.js.map
